module.exports = __webpack_public_path__ + "img/9.1.2.0846dedf.svg";